import Vue from "vue";
import Vuex from "vuex";

Vue.use (Vuex);

export default new Vuex.Store({
state:{
    headerIndex: 0, //头部导航栏选中记录
    aboutPageCurrentSelected: 0, //关于晨新二级界面选中记录
    hxjsPageCurrentSelected: 0, //核心技术二级界面选中记录
    cpzxPageCurrentSelected: 0, //产品中心二级界面选中记录
    joinusPageCurrentSelected: 0, //加入我们二级界面选中记录
    scrollTop: 0, //监听页面滚动距离，计算导航条透明度

},

getters:{

},
mutations:{

    changeHeaderIndex(state,num){
        state.headerIndex = num;

    },
    changeaboutPageCurrentSelected(state,num){
        state.aboutPageCurrentSelected = num;

    },
    changehxjsPageCurrentSelected(state,num){
        state.hxjsPageCurrentSelected = num;

    },
    changecpzxPageCurrentSelected(state,num){
        state.cpzxPageCurrentSelected = num;

    },
    changejoinusPageCurrentSelected(state,num){
        state.joinusPageCurrentSelected = num;

    },
    scrollTopChange(state,num){
        state.scrollTop = num;
     
    }


},

actions:{

}, 
modules:{



}
});


// WEBPACK FOOTER //
// ./src/store/index.js